module.exports = __webpack_public_path__ + "static/media/popo-sad.4b942f3a.png";